<h1 style="
 font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
   Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
 font-weight: 500;
 color: #105481;
 margin-bottom: 0.5rem;
 font-size: 2.5rem;
 font-weight: 500;
 line-height: 1.2;
 padding-bottom: 20px;
 " id="editInrefHeader" #target>
  {{heading && !copyField && !newInref ? heading : 'Tilfoj fordelingsregel'}}
</h1>

<form (ngSubmit)="submitClicked(target)" [formGroup]="profileForm" >
  <table style="width: 100%; height: 155px;" class="add-def-tab" aria-describedby="table">
    <th></th>
    <tr>
      <td style="width: 16%">
        <label appendTo="body" class="text" for="stat" id="infReflabel">Titel<span class="mandatory">*</span>:</label>
      </td>

      <td>
        <div class="p-inputgroup">
          <input required formControlName="title" id="infRefInput" pInputText appendTo="body"
            [(ngModel)]="infRef.title" name="infRefName">
            <app-popover-btn title="Titel" id="typepopup"
            text="Fri beskrivelse for brugeren til at angive en sigende tekst for fordelingsreglen."></app-popover-btn>
        </div>
        <div *ngIf="profileForm.controls['title'].invalid && profileForm.controls['title'].touched">
          <div *ngIf="profileForm.controls['title'].errors" class="errormsg">
            Felt er påkrævet
          </div>
        </div>
        <div *ngIf="visible" class="errormsg">
          {{alertmessage}}
        </div>
      </td>
    </tr>

    <tr>
      <td style="width: 19%">
        <label appendTo="body" class="text" for="stat" id="typeInput">Kanaltype<span class="mandatory">*</span>:</label>
      </td>
      <td>
        <div class="p-inputgroup">
          <p-dropdown  formControlName="channelType" id="typeDropdown" placeholder="Vælg fra liste" [options]="channelTypes"
            [(ngModel)]="infRef.channelType" name="serviceType">
          </p-dropdown>

          <app-popover-btn title="Kanaltype" id="typepopup"
            text="Det er kun muligt at vælge ”Fagsystem”."></app-popover-btn>
        </div>
        <div *ngIf="profileForm.controls['channelType'].invalid && profileForm.controls['channelType'].touched">
          <div *ngIf="profileForm.controls['channelType'].errors" class="errormsg">
            Felt er påkrævet
          </div>
        </div>
      </td>
    </tr>

    <tr>
      <td style="width: 16%">
        <label appendTo="body" class="text" for="stat" id="infReflabel">Emne<span class="mandatory">*</span>:</label>
      </td>

      <td>
        <div class="p-inputgroup">
          <input required formControlName="kleEmne" id="infRefInput" pInputText appendTo="body"
            [(ngModel)]="infRef.kleEmne" name="infRefName">
            <app-popover-btn title="Emne" id="typepopup"
            text="Emne angivet efter KL Emnesystematik (KLE), se evt. 
            <a href='http://www.kle-online.dk' target='_blank'>www.kle-online.dk</a>.</br>
            Stjerne (*) kan bruges som wildcard i emneangivelsen, eksempelvis: 60.01.*">
            </app-popover-btn>
        </div>
        <div *ngIf="profileForm.controls['kleEmne'].invalid && profileForm.controls['kleEmne'].touched">
          <div *ngIf="profileForm.controls['kleEmne'].errors?.['required']" class="errormsg">
            Felt er påkrævet
          </div>
          <div *ngIf="profileForm.controls['kleEmne'].errors?.['pattern']" class="errormsg">
            Fejl: Angiv et gyldigt KLE-emne som f.eks. 01.*.*, 01.05.* eller 01.05.08
          </div>
        </div>
      </td>
    </tr>

    <tr>
      <td style="width: 16%">
        <label appendTo="body" class="text" for="stat" id="infReflabel">Handlingsfacet<span class="mandatory">*</span>:</label>
      </td>

      <td>
        <div class="p-inputgroup">
          <input required formControlName="handlingFacet" id="infRefInput" pInputText appendTo="body"
            [(ngModel)]="infRef.handlingFacet" name="infRefName">
            <app-popover-btn title="Handlingsfacet" id="typepopup"
            text="Handlingsfacet angivet efter KL Emnesystematik (KLE), se evt. 
            <a href='http://www.kle-online.dk'  target='_blank'>www.kle-online.dk</a>."></app-popover-btn>
        </div>
        <div *ngIf="profileForm.controls['handlingFacet'].invalid && profileForm.controls['handlingFacet'].touched">
          <div *ngIf="profileForm.controls['handlingFacet'].errors?.['required']" class="errormsg">
            Felt er påkrævet
          </div>
          <div *ngIf="profileForm.controls['handlingFacet'].errors?.['pattern']" class="errormsg">
            Fejl: Angiv en gyldig KLE-facet på formen [A-Z,Æ,Ø,Å][0-9][0-9], som f.eks. A21
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td style="width: 16%">
        <label appendTo="body" class="text" for="stat" id="infReflabel">Gyldig fra<span class="mandatory">*</span>:</label>
      </td>

      <td>
        <div class="p-inputgroup">
          <p-calendar
          validation
          appendTo="body"
          dateFormat="dd/mm/yy"
          [(ngModel)]="infRef.validFrom"
          formControlName="validFrom"
          inputId="min-max"
          [minDate]="minimumDate"
          (onSelect)="moveDate()"
          [showIcon]="true"
          [monthNavigator]="true"
          [yearNavigator]="true"
          yearRange="2018:2040"
        >
        </p-calendar>
            <app-popover-btn title="Gyldig fra" id="typepopup"
            text="Dato, hvorfra fordelingsreglen er gyldig. Datoen er inklusiv."></app-popover-btn>
        </div>
        <div *ngIf="profileForm.controls['validFrom'].invalid && profileForm.controls['validFrom'].touched">
          <div *ngIf="profileForm.controls['validFrom'].errors" class="errormsg">
            Felt er påkrævet
          </div>
        </div>
        <div *ngIf="isDateRangeValid" class="errormsg">
          {{validFromErrorMessage}}
        </div>
      </td>
    </tr>

    <tr>
      <td style="width: 16%">
        <label appendTo="body" class="text" for="stat" id="infReflabel">Gyldig til<span class="mandatory">*</span>:</label>
      </td>

      <td>
        <div class="p-inputgroup">
            <p-calendar
            validation
            appendTo="body"
            dateFormat="dd/mm/yy"
            [(ngModel)]="infRef.validTo"
            formControlName="validTo"
            inputId="min-max"
            [minDate]="minimumDate"
            (onSelect)="moveDate()"
            [showIcon]="true"
            [monthNavigator]="true"
            [yearNavigator]="true"
            yearRange="2018:2040"
          >
          </p-calendar>
            <app-popover-btn title="Gyldig til" id="typepopup"
            text="Dato, hvortil fordelingsreglen er gyldig. Datoen er inklusiv."></app-popover-btn>
        </div>
        <div *ngIf="profileForm.controls['validTo'].invalid && profileForm.controls['validTo'].touched">
          <div *ngIf="profileForm.controls['validTo'].errors" class="errormsg">
            Felt er påkrævet
          </div>
        </div>
        <div *ngIf="isDateRangeValid" class="errormsg">
          {{validFromErrorMessage}}
        </div>
      </td>
    </tr>

    <tr>
      <td style="width: 19%">
        <label appendTo="body" class="text" for="stat" id="typeInput">Systemnavn<span class="mandatory">*</span>:</label>
      </td>
      <td>
        <div class="p-inputgroup">
          <p-dropdown  formControlName="systemName" id="typeDropdown" placeholder="Vælg fra liste" [options]="systemNames"
            [(ngModel)]="infRef.systemName"  name="serviceType">
          </p-dropdown>

          <app-popover-btn title="Systemnavn" id="typepopup"
            text="Navn på det system, som skal modtage dokumenter, der skal fordeles efter denne fordelingsregel. 
            </br>
            Systemet skal være oprettet</br> i Administrationssystemet for at kunne vælges fra listen."
            >
          </app-popover-btn>
        </div>
        <div *ngIf="profileForm.controls['systemName'].invalid && profileForm.controls['systemName'].touched">
          <div *ngIf="profileForm.controls['systemName'].errors" class="errormsg">
            Felt er påkrævet
          </div>
        </div>
      </td>
    </tr>
  </table>
</form>
<table id="restData" aria-label="table" class="text"
style="border-spacing: 10px 20px; border-collapse: separate;">
<th></th>
  <tr><td id="uuid">System UUID:</td> <td *ngIf="!copyField" style="padding-left: 110px;"> {{infRef.systemUUID }}</td></tr>
  <tr ><td>Endpoint:</td> <td *ngIf="!copyField" style="padding-left: 110px;"> {{ infRef.endPointURI }}</td></tr>
  <tr><td>Opdateret af:
  </td> <td *ngIf="!copyField" style="padding-left: 110px;">{{ infRef.changedBy}}</td></tr>
  <tr><td>Opdateret Dato:
  </td> <td *ngIf="!copyField" style="padding-left: 110px;">{{ changedDate}}</td></tr>
</table>
<div *ngIf="isEnable; else notEditable">
  <span>
    <button pButton class="add-button" label="Gem" type="submit"
      (click)="submitClicked(target)" id="gemButton"></button>
  </span>

  <span style="padding-left: 15px;">
    <button *ngIf="!newInref && !copyField" pButton label="Kopier" class="add-button" (click)="copyClick()" id="annullerbutton2"></button>

  </span>
  <span>
    <button *ngIf="!newInref && !copyField" pButton label="Slet" class="add-button secondary" (click)="deleteClick()" id="annullerbutton2"></button>

  </span>
  <span>
    <button pButton label="Annuller" class="add-button secondary" (click)="cancelClick()" id="annullerbutton2"></button>

  </span>
</div>
<ng-template #notEditable>
  <span>
    <button pButton label="Annuller" class="add-button secondary" (click)="cancelClick()" id="annullerbutton2"></button>
  </span>
</ng-template>

